<script context="module">
  export function focusNext(modal) {
    const nodes = modal.querySelectorAll("*");
    const tabbable = Array.from(nodes).filter((n) => n.tabIndex >= 0);

    let index = tabbable.indexOf(document.activeElement);
    index += 1;
    if (index < tabbable.length) {
      tabbable[index].focus();
    }
  }
</script>

<script>
  import { createEventDispatcher, onDestroy } from "svelte";
  import { Spacer } from "./layout";

  const dispatch = createEventDispatcher();
  const close = async () => {
    dispatch("close");
  };

  export let modal = undefined;
  export let minHeight = "inherit";
  export let minWidth = "inherit";
  export let padding = true;
  export let closeButton = true;
  export let closeOnEsc = true;
  export let closeOnOuterClick = true;
  export let cancelButton = true;

  let background;

  const handle_keydown = (e) => {
    if (e.key === "Escape" && closeOnEsc) {
      close();
      return;
    }

    if (e.key === "Tab") {
      // trap focus
      const nodes = modal.querySelectorAll("*");
      const tabbable = Array.from(nodes).filter((n) => n.tabIndex >= 0);

      let index = tabbable.indexOf(document.activeElement);
      if (index === -1 && e.shiftKey) index = 0;

      index += tabbable.length + (e.shiftKey ? -1 : 1);
      index %= tabbable.length;

      tabbable[index].focus();
      e.preventDefault();
    }
  };

  const handleOuterClick = (e) => {
    if (closeOnOuterClick && e.target === background) {
      e.preventDefault();
      close();
    }
  };

  const previously_focused = typeof document !== "undefined" && document.activeElement;

  if (previously_focused) {
    onDestroy(() => {
      previously_focused.focus();
    });
  }
</script>

<svelte:window on:keydown={handle_keydown} />
<div class="modal-background" bind:this={background} on:click={handleOuterClick}>
  <div
    class="modal"
    class:padding
    style="min-height:{minHeight}; min-width:{minWidth}"
    role="dialog"
    aria-modal="true"
    bind:this={modal}
    on:click={(e) => {
      e.stopPropagation();
      dispatch("click");
    }}>
    {#if closeButton}
      <button class="close-icon" on:click={close}>x</button>
    {/if}
    <slot />
    <div class="actions">
      {#if cancelButton}
        <Spacer />
        <button class="cancel" on:click={close}>Annuler</button>
      {/if}
    </div>
  </div>
</div>

<style>
  .modal-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 99;
  }

  .modal {
    position: absolute;
    left: 50%;
    top: 50%;
    max-width: 32em;
    transform: translate(-50%, -50%);
    padding: 0;
    border-radius: 0.2em;
    background: white;
    z-index: 100;
  }

  @media screen and (max-width: 600px) {
    .modal {
      width: 100%;
    }
  }

  .modal.padding {
    padding: 1em;
  }

  .actions {
    display: flex;
  }

  button.cancel {
    margin-right: 1em;
    cursor: pointer;
    border-radius: 5px;
    padding: 0.5rem;
  }

  button.close-icon {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 9999;
    width: 25px;
    color: #666;
    font-size: 24px;
    line-height: 1;
    outline: 0;
    cursor: pointer;
    text-align: center;
    font-family: Arial, sans-serif;
    background: #fff;
    border: none;
    padding: 0;
  }
</style>
